import { CommApiInstance } from "Utils/CommApiInstance";

const Oauth2LstApi  = async (
) => {
    return await CommApiInstance.post(`athn/login/oauth2_lst`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default Oauth2LstApi;